import { OutSourceStatus } from "@/constants/outsource-status";

export interface FilterOptions {
  search: string;
  vehicle?: VehicleFilter;
  pickUp?: LocationFilter;
  dropOff?: LocationFilter;
  trajectory?: TrajectoryFilter;
  trajectoryOutsourceStatus?: TrajectoryOutsourceStatusFilter;
  tags?: TagFilter;
  /**
   * Alleen de trajecten waarvoor op dit moment automatisch gepland wordt (werkitem 7333). Server-side, want
   * de lijst is gepagineerd; in de browser filteren zou een greep uit één pagina opleveren.
   */
  inActivePlanRun?: boolean;
  active?: boolean;
  archived?: boolean;
}

export interface VehicleFilter {
  enabled: boolean;
  licensePlate?: string;
  chassisNumber?: string;
  weightFrom?: number | null;
  weightTo?: number | null;
}

export interface LocationFilter {
  enabled: boolean;
  location?: string;
  precision?: number | null;
  timeWindowFrom?: number | null;
  timeWindowTo?: number | null;
}

export interface TrajectoryFilter {
  enabled: boolean;
  leadTimeFrom?: number | null;
  leadTimeTo?: number | null;
  distanceFrom?: number | null;
  distanceTo?: number | null;
}

export interface TrajectoryOutsourceStatusFilter {
  enabled: boolean;
  status?: OutSourceStatus[];
}

/** Spaarbak-tagfilter (alleen Te plannen-tab): selectie van tags en/of "zonder tag" (OR). */
export interface TagFilter {
  enabled: boolean;
  tags?: string[];
  withoutTag?: boolean;
}

export const DefaultFilterRequest = (): FilterOptions => {
    return {
      search: '',
      vehicle: {
        enabled: false,
        licensePlate: '',
        chassisNumber: '',
        weightFrom: null,
        weightTo: null,
      },
      pickUp: {
        enabled: false,
        location: '',
        precision: null,
        timeWindowFrom: null,
        timeWindowTo: null,
      },
      dropOff: {
        enabled: false,
        location: '',
        precision: null,
        timeWindowFrom: null,
        timeWindowTo: null,
      },
      trajectory: {
        enabled: false,
        leadTimeFrom: null,
        leadTimeTo: null,
        distanceFrom: null,
        distanceTo: null,
      },
      trajectoryOutsourceStatus: {
        enabled: false,
        status: [],
      },
      tags: {
        enabled: false,
        tags: [],
        withoutTag: false,
      }
    }
}